<template>
  <div class="car-items">
    <div class="car-item" v-if="optional">
    <checkbox :data-js="`selection__option--no-selection-${option.avGroup}`"
              :label="$t('equipmentSelection.noEquipment')"
              @onClick="updateOptionalValue"
              :is-selected="isSelected(-1)"/>
    </div>
    <div class="car-item" v-for='(item, index) in items'
         :key="index">
      <checkbox :data-js="`selection__option--${item.av.id}`"
                :label="item.av | optionTranslate"
                @onClick="updateValue(item.av.id)"
                :is-selected="isSelected(item)"/>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';

export default {
  name: 'MultipleEquipmentCheckbox',
  props: [
    'value',
    'items',
    'optional',
    'index',
    'selection',
    'option'
  ],
  data () {
    return {
      selectedItems: this.value || [],
      optionalValue: (this.value && this.value.includes(-1))
    }
  },
  methods: {
    updateOptionalValue () {
      this.optionalValue = !this.optionalValue;
      if (this.optionalValue) {
        this.selectedItems = [];
        this.selectedItems.push(-1);
      } else {
        this.selectedItems = [];
      }
      this.$set(this.selection, 'selectedAvs', this.selectedItems);
      this.$emit('updateAvs', this.selectedItems);
    },
    updateValue (id) {
      if (this.selectedItems.includes(-1)) this.selectedItems = [];
      if (this.selectedItems.includes(id)) {
        this.selectedItems = this.selectedItems.filter(i => i !== id);
      } else {
        this.selectedItems.push(id);
      }
      this.optionalValue = false;
      this.$set(this.selection, 'selectedAvs', this.selectedItems);
      this.$emit('updateAvs', this.selectedItems);
    },
    isSelected (item) {
      if (item === -1 && this.optionalValue) return true;
      if (item && item.av) {
        return item.av.id === this.selectedItems || (this.selectedItems && this.selectedItems.includes(item.av.id))
      } else {
        return false;
      }
    }
  },
  watch: {
    value: function () {
      this.selectedItems = this.value || [];
      this.optionalValue = (this.value && this.value.includes(-1));
    }
  },
  components: {
    Checkbox
  }
}
</script>
